import type { LeverageDirection, LeverageOperationStatus, LeverageTier } from './types';

/**
 * Contas da alavancagem do lado do navegador — as mesmas do servidor
 * (server/src/modules/leverage/leverage.rules.ts), para a prévia bater com o
 * que vai ser gravado. Os % andam em bp: 2,5% = 250, 100% = 10000.
 */

export const FULL_BP = 10_000;

export const DIRECTION_LABELS: Record<LeverageDirection, string> = { BUY: 'Compra', SELL: 'Venda' };
export const OPERATION_STATUS_LABELS: Record<LeverageOperationStatus, string> = { OPEN: 'Aberta', CLOSED: 'Encerrada' };

const percentFormat = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });

/** 250 → "2,5%". */
export const formatBp = (bp: number): string => `${percentFormat.format(bp / 100)}%`;

/** 250 → "2,5", para preencher o campo de %. */
export const bpToInput = (bp: number): string => (bp ? percentFormat.format(bp / 100) : '');

/** "2,5" / "2.5" → 250; vazio ou inválido → 0. Até duas casas. */
export function inputToBp(value: string): number {
  const parsed = Number(value.trim().replace('%', '').replace(',', '.'));
  return Number.isFinite(parsed) && parsed > 0 ? Math.round(parsed * 100) : 0;
}

/** Capital × %, para baixo — como o servidor grava. */
export const allocationAmount = (capital: number, percentBp: number): number => Math.floor((capital * percentBp) / FULL_BP);

/** O % da maior faixa que o capital alcança; `null` se nenhuma alcança. */
export function suggestedPercent(tiers: readonly LeverageTier[], capital: number): number | null {
  let found: number | null = null;
  for (const tier of [...tiers].sort((a, b) => a.minCapital - b.minCapital)) {
    if (tier.minCapital <= capital) found = tier.percentBp;
  }
  return found;
}
